import GAME_STRUCT from '../../entities/game';

const CALCULATED_GAME_STRUCT = {
  ...GAME_STRUCT,
  STATUS: 'status',
};

export default CALCULATED_GAME_STRUCT;
